<template>
  <v-row>
    <v-col sm="6" >
      <v-form v-on:submit.prevent="submit()" v-model="valid" ref="form">
        <v-card flat :border="true">
          <v-card-text>
            <v-text-field
              :label="t('name')"
              :model-value="workOrderCategory.name"
              readonly
              disabled
              variant="underlined"
            ></v-text-field>

            <v-text-field
              :label="t('color')"
              v-model="workOrderCategory.color"
              :rules="[rules.required, rules.hexColor]"
              placeholder="#A5BAE9"
              required
              variant="underlined"
            >
              <template v-slot:append-inner>
                <v-menu :close-on-content-click="false" location="bottom end">
                  <template v-slot:activator="{ props: menuProps }">
                    <div
                      v-bind="menuProps"
                      class="color-swatch"
                      :style="{ backgroundColor: isValidColor ? workOrderCategory.color : 'transparent' }"
                    ></div>
                  </template>
                  <v-color-picker
                    :model-value="isValidColor ? workOrderCategory.color : '#FFFFFF'"
                    @update:model-value="(value: string) => workOrderCategory.color = value.toUpperCase()"
                    mode="hex"
                    :modes="['hex']"
                    elevation="0"
                  ></v-color-picker>
                </v-menu>
              </template>
            </v-text-field>

            <div class="text-caption text-medium-emphasis mb-1">{{ t('preview') }}</div>
            <CategoryBadge :category="workOrderCategory" />
          </v-card-text>
          <v-card-actions>
            <v-btn color="orange-darken-2" depressed type="submit" v-show="!loading" :disabled="!valid">
              {{ buttonText }}
            </v-btn>
            <v-progress-circular indeterminate color="orange-darken-2" v-show="loading"></v-progress-circular>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { ref, computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import CategoryBadge from '@/components/WorkOrders/CategoryBadge.vue'

const props = defineProps({
  workOrderCategory: {
    type: Object as PropType<{ id: number, name: string, color: string }>,
    required: true
  },
  submit: {
    type: Function,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  buttonText: {
    type: String,
    default: 'Save'
  }
})

const { t } = useI18n()

const valid = ref(false)
const form = ref()

const hexColorPattern = /^#[0-9A-Fa-f]{6}$/

const isValidColor = computed(() => hexColorPattern.test(props.workOrderCategory.color || ''))

const rules = {
  required: (value: string) => !!value || t('fieldRequired'),
  hexColor: (value: string) => hexColorPattern.test(value || '') || t('invalidHexColor'),
}
</script>

<style scoped lang="scss">
.color-swatch {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
</style>
